import createReducer from '../../common/util/createReducer';
import {downloadFile} from '../../common/util/file';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'salesAndStockList': [],
  'downloading': false,
};

export const dailyVehiclesSalesAndStockSummary = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_DAILY_VEHICLES_SALES_SUMMARY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_DAILY_VEHICLES_SALES_SUMMARY]: (state, action) => ({
      ...state,
      'loading': false,
      'salesAndStockList': action.response.data,
    }),
    [ActionTypes.FETCHED_DAILY_VEHICLES_SALES_SUMMARY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'salesAndStockList': [],
    }),
    [ActionTypes.DOWNLOADING_DAILY_VEHICLES_SALES_SUMMARY]: (state) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOADED_DAILY_VEHICLES_SALES_SUMMARY]: (state) => {
      downloadFile(action.response.data);

      return ({
        ...state,
        'downloading': false,
      });
    },
    [ActionTypes.DOWNLOADED_DAILY_VEHICLES_SALES_SUMMARY_FAILED]: (state) => ({
      ...state,
      'downloading': false,
    }),
  })(state, action);
};
